"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Business = _interopRequireDefault(require("@material-ui/icons/Business"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));

var _solarReact = require("@solar/solar-react");

var _ProfileItem = _interopRequireDefault(require("../ProfileItem"));

var _CertificateProfile = _interopRequireWildcard(require("./CertificateProfile"));

var _CertificateAssignInspectors = _interopRequireDefault(require("./CertificateAssignInspectors"));

var _ProductTypeSelector = _interopRequireDefault(require("../../dist/Product/ProductTypeSelector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import ProductCRMChanges from './ProductCRMChanges';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    media: {
      paddingTop: '50%'
    },
    field: {
      margin: 12,
      marginLeft: 24,
      marginRight: 24
    },
    body: {
      margin: theme.spacing(3),
      maxWidth: 600
    },
    buttons: {
      marginTop: theme.spacing(1),
      justifyContent: 'space-between'
    },
    em: {
      fontWeight: 'bold'
    },
    fade: {
      color: theme.palette.text.secondary
    }
  };
});

var CertificateInfo = function CertificateInfo(_ref) {
  var certificate = _ref.certificate,
      openManufacturer = _ref.openManufacturer,
      openUnit = _ref.openUnit,
      openPublic = _ref.openPublic,
      handleResponsibleClick = _ref.handleResponsibleClick,
      assignedInspectors = _ref.assignedInspectors,
      _ref$asInspectorAdmin = _ref.asInspectorAdmin,
      asInspectorAdmin = _ref$asInspectorAdmin === void 0 ? false : _ref$asInspectorAdmin,
      labels = _ref.labels;
  var classes = useStyles();
  var productTypes = certificate.productTypes,
      product = certificate.product,
      productionUnit = certificate.productionUnit,
      inspector = certificate.inspector;
  var title = product.title,
      _product$codes = product.codes,
      codes = _product$codes === void 0 ? [] : _product$codes;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    text: labels.preview,
    icon: /*#__PURE__*/_react["default"].createElement(_Link["default"], null),
    onClick: function onClick() {
      return openPublic(certificate.key);
    }
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.product), /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_core.ListItem, null, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "button"
    }, title)
  })), product.types.map(function (_ref2) {
    var _productTypes$include, _productTypes$include2;

    var key = _ref2.key,
        productTypeTitle = _ref2.title;
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: key
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, ((_productTypes$include = productTypes === null || productTypes === void 0 ? void 0 : productTypes.includes(key)) !== null && _productTypes$include !== void 0 ? _productTypes$include : false) && /*#__PURE__*/_react["default"].createElement(_Check["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      primary: "".concat(productTypeTitle, " (").concat(key, ")"),
      className: (0, _clsx2["default"])(_defineProperty({}, classes.fade, (_productTypes$include2 = !(productTypes !== null && productTypes !== void 0 && productTypes.includes(key))) !== null && _productTypes$include2 !== void 0 ? _productTypes$include2 : true))
    }));
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.certificate), /*#__PURE__*/_react["default"].createElement(_CertificateProfile["default"], _extends({}, (0, _CertificateProfile.certificateMapper)(certificate, null, null, null, labels), {
    onClickOwner: function onClickOwner() {
      return openManufacturer(productionUnit.manufacturer.id);
    },
    onClickProduction: function onClickProduction() {
      return openUnit(productionUnit._id);
    },
    labels: labels
  })), !!inspector && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.inspector), /*#__PURE__*/_react["default"].createElement(_core.List, {
    disablePadding: true
  }, /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Business["default"], null),
    text: inspector.name
  }), /*#__PURE__*/_react["default"].createElement(_CertificateAssignInspectors["default"], {
    info: labels.inspectorAssignment,
    users: inspector.representatives.map(function (_ref3) {
      var _id = _ref3._id,
          person = _ref3.person;
      return _objectSpread(_objectSpread({}, person), {}, {
        _id: _id
      });
    }),
    assignedUsers: assignedInspectors,
    editable: asInspectorAdmin,
    handleUserClick: handleResponsibleClick
  }))), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.codes), /*#__PURE__*/_react["default"].createElement(_core.List, null, codes.map(function (code) {
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: code
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      key: code,
      primary: code
    }));
  })));
};

CertificateInfo.defaultProps = {
  className: ''
};
var _default = CertificateInfo;
exports["default"] = _default;